module.exports = __webpack_public_path__ + "media/images/faq/brand9-370674ff06b646b7fb464d47da3aba9e.png";